import React, {useEffect, useState} from 'react';
import {useQueryClient} from "react-query";
import {Grid} from "@material-ui/core";
import {ComboSelect, Dialog, FormDialog, MaskedNumber}from "../../../../controls";
import axios from 'axios';
import __ from "lodash";
import moment from "moment";
import Validator from "../../validators/FuelPolicyValidator";

const FuelPolicyDialog = (_props) => {
  const props = {
    canEdit: false,
    ..._props,
  }

  const SystemData = props.systemData;
  const classes = props.classes;

  const eventBus = SystemData.eventBus;

  const [dialogState, setDialogState] = useState({
    showDialog: false,
    record: {},
    title: 'Amend Fuel Policy',
  });

  const queryClient = useQueryClient();

  useEffect(()=> {
    const open = async (params) => {
      const {canEdit, tripData, fuelOrderData} = params;

      const {tripLegUuid, airlineCode, flightNo, scheduledDepartureTimeUTC} = tripData;
      const {fuelOrderUuid, fuelPolicyType, editTankerToLand, tankerToLand } = fuelOrderData;
      const record = {tripLegUuid, airlineCode, flightNo, scheduledDepartureTimeUTC, fuelOrderUuid, fuelPolicyType, editTankerToLand, tankerToLand}
      const title = `Amend Fuel Policy for ${airlineCode}${flightNo} ${moment.utc(scheduledDepartureTimeUTC).format("DD/MMM")}`;

      setDialogState({...dialogState, showDialog:true, canEdit, record, title});
    }

    eventBus.bind("FuelPolicyDialog.open", open);

    return () => {
      eventBus.unbind("FuelPolicyDialog.open", open);
    }
  }, [dialogState, eventBus, queryClient]);

  if (dialogState.showDialog) {
    return (
      <FormDialog
        title={dialogState.title}
        message="Please select the applicable fuel policy"
        open={dialogState.showDialog}
        record={dialogState.record}
        dialogOptions={{maxWidth: "sm", fullWidth: false}}
        classes={classes}
        validator={Validator}
        buttons = {{
          save:{icon: "check_circle", key: "Update", label: "Update", color: "primary", disabled: (status)=>{return status.error}},
          cancel:{icon: "cancel", key: "Cancel", label: "Cancel", color: "primary"}
        }}
        onChange={(state) => {
          if (state.buttonPressed === "save") {
            const record = state.record;
            axios.put(
              `${props.apiSitePrefix}/fuelorder/updateFuelPolicy`, record
            ).then(saved => {
              setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
              if (props.afterSave) {
                props.afterSave();
              }
              if (typeof props.onClose === 'function') {props.onClose()}
            }).catch(error => {
              SystemData.openAlert("Error Saving Fuel Policy", "An unexpected error has occurred while saving the policy change.");
            })
          } else {
            setDialogState({...dialogState, showDialog: false, record: null, handleSave: null});
            if (typeof props.onClose === 'function') {props.onClose()}
          }
        }}
      >
        <Grid container spacing={1} checkChildren={true} >
          <Grid item xs={8} style={{ width:200 }} checkChildren={true} >
            <ComboSelect
              id="fuelPolicyType"
              group="FUEL POLICY TYPE"
              subGroup=""
              fullWidth
              returnType={"objectOnly"}
              onChange={(returnObject, props) => {
                const {onChange, recordChange, record} = props;
                if (returnObject && !__.isEmpty(returnObject)) {
                  const editTankerToLand =  returnObject.data?.tankerToLand || false;
                  recordChange({...record, fuelPolicyType: returnObject.code, tankerToLand: editTankerToLand ? 0 : undefined , editTankerToLand});
                }
              }}
          />
          </Grid>
          <Grid item xs={4} style={{ width: 100 }} checkChildren={true} >
            {(record) => (
              <MaskedNumber
                id="tankerToLand"
                fixedDecimalScale={true}
                decimalScale={1}
                suffix={" tonnes"}
                style={{ fontSize: "0.875rem", textAlign: "right" }}
                valueCap={150}
                disabled={!record.editTankerToLand}
              />
            )}
          </Grid>
        </Grid>
      </FormDialog>
    )
  }
  return (<></>);
}

export default FuelPolicyDialog;
